import { PageHeader } from '@/components/Base/PageHeader/PageHeader'
import ReportParametersPopover from '@/components/Base/ReportParametersPopover/ReportParametersPopover'
import { AxiomReportType, ModuleTypePageTitle } from '@/enums/axiom-report.enum'
import { IReportDTO } from '@/interfaces/report.interface'
import StaticReportsLayout from '@/Layouts/StaticReportsLayout'
import { getReportTypeTitle } from '@/utils/utils'
import { ReportFilter } from '@components/ReportFilter/ReportFilter'
import { Box, Divider, Stack } from '@mui/material'
import React, { ReactElement, useEffect, useState } from 'react'

export const ReportDashboardLayout: React.FC<{
  children: ReactElement
  selectedReport: IReportDTO
  navigation: ReactElement
  action?: ReactElement
  fitAllInView?: boolean
}> = ({ children, selectedReport, navigation, action, fitAllInView }) => {
  const [containerHeight, setContainerHeight] = useState('26rem')
  const reportType: string = selectedReport.reportType

  const calculateHeight = () => {
    const h = document.body.clientHeight
    setContainerHeight(`${(h - 272) / 16}rem`)
  }

  useEffect(() => {
    calculateHeight()
  }, [])

  return (
    <StaticReportsLayout title={ModuleTypePageTitle.REPORTING}>
      <Box
        display='grid'
        gridTemplateRows='auto auto 1fr auto'
        px={4}
        gap={4}
        height='100%'
        data-cy='reportDashboard'
        boxSizing='border-box'
      >
        <PageHeader
          title={getReportTypeTitle(reportType as AxiomReportType)}
          childrenPosition='flex-start'
          showBackButton={true}
        >
          <ReportParametersPopover selectedReport={selectedReport} />
        </PageHeader>
        <Stack
          direction='row'
          gap={8}
          justifyContent='space-between'
          alignItems='center'
        >
          <ReportFilter selectedReport={selectedReport} />
          {action}
        </Stack>
        <Box
          display='grid'
          height={containerHeight}
          overflow='hidden'
          boxSizing='border-box'
          position='relative'
        >
          {fitAllInView ? (
            children
          ) : (
            <Box display='grid' overflow='auto' pb={1} boxSizing='border-box'>
              {children}
            </Box>
          )}
        </Box>
        <Box display='grid' gridTemplateRows='auto auto' gap={2}>
          <Divider />
          {navigation}
        </Box>
      </Box>
    </StaticReportsLayout>
  )
}
